export interface HrAttendanceEvent {
  attendanceEventId?: number;
  owningCompanyId?: number;
  employeeId?: number;
  customerId?: number;
  employeeNumber?: string;
  employeeName?: string;
  eventType?: string;
  eventTime?: string;
  source?: string;
  sourceReference?: string;
  sourceDeviceId?: string;
  eventStatus?: string;
  latitude?: number;
  longitude?: number;
  locationName?: string;
  geofenceId?: number;
  shipmentId?: number;
  deliveryId?: number;
  vehicleId?: number;
  mobilizationId?: number;
  warehouseId?: number;
  clearanceAssignmentId?: number;
  projectId?: number;
  notes?: string;
  ingestedByCustomerId?: number;
  createdAt?: string;
}

export interface HrTimesheetLine {
  timesheetLineId?: number;
  timesheetId?: number;
  employeeId?: number;
  workDate?: string;
  lineType?: string;
  startTime?: string;
  endTime?: string;
  regularHours?: number;
  overtimeHours?: number;
  nightHours?: number;
  holidayHours?: number;
  standbyHours?: number;
  unpaidAbsenceDays?: number;
  driveDutyHours?: number;
  shipmentId?: number;
  deliveryId?: number;
  vehicleId?: number;
  mobilizationId?: number;
  warehouseId?: number;
  clearanceAssignmentId?: number;
  projectId?: number;
  payrollInputCode?: string;
  payrollPosted?: boolean;
  notes?: string;
}

export interface HrTimesheet {
  timesheetId?: number;
  owningCompanyId?: number;
  employeeId?: number;
  employeeNumber?: string;
  employeeName?: string;
  workerCategory?: string;
  periodStart?: string;
  periodEnd?: string;
  timesheetStatus?: string;
  regularHours?: number;
  overtimeHours?: number;
  nightHours?: number;
  holidayHours?: number;
  standbyHours?: number;
  unpaidAbsenceDays?: number;
  driveDutyHours?: number;
  payrollInputJson?: string;
  submittedByCustomerId?: number;
  submittedAt?: string;
  approvedByCustomerId?: number;
  approvedAt?: string;
  lockedByCustomerId?: number;
  lockedAt?: string;
  payrollPosted?: boolean;
  payrollBatchId?: number;
  notes?: string;
  createdAt?: string;
  updatedAt?: string;
  lines?: HrTimesheetLine[];
}

export interface HrAttendanceException {
  attendanceExceptionId?: number;
  owningCompanyId?: number;
  employeeId?: number;
  employeeNumber?: string;
  employeeName?: string;
  timesheetId?: number;
  timesheetLineId?: number;
  attendanceEventId?: number;
  exceptionType?: string;
  severity?: string;
  exceptionStatus?: string;
  description?: string;
  eventDate?: string;
  resolvedByCustomerId?: number;
  resolvedAt?: string;
  resolutionNotes?: string;
  createdAt?: string;
}

export interface HrTimeAdjustmentRequest {
  timeAdjustmentRequestId?: number;
  owningCompanyId?: number;
  employeeId?: number;
  employeeNumber?: string;
  employeeName?: string;
  requestStatus?: string;
  adjustmentType?: string;
  eventDate?: string;
  startTime?: string;
  endTime?: string;
  hours?: number;
  reason?: string;
  shipmentId?: number;
  deliveryId?: number;
  vehicleId?: number;
  mobilizationId?: number;
  warehouseId?: number;
  clearanceAssignmentId?: number;
  projectId?: number;
  requestedByCustomerId?: number;
  requestedAt?: string;
  approvedByCustomerId?: number;
  approvedAt?: string;
  resolvedAt?: string;
  decisionReason?: string;
}

export interface HrTimeDashboard {
  owningCompanyId?: number;
  attendanceEventsToday?: number;
  openExceptions?: number;
  draftTimesheets?: number;
  submittedTimesheets?: number;
  approvedTimesheets?: number;
  regularHours?: number;
  overtimeHours?: number;
  driveDutyHours?: number;
  recentEvents?: HrAttendanceEvent[];
  openExceptionRows?: HrAttendanceException[];
  timesheets?: HrTimesheet[];
}

export interface HrTimesheetGenerationRequest {
  owningCompanyId?: number;
  employeeId?: number;
  periodStart?: string;
  periodEnd?: string;
}

export interface HrTimesheetDecisionRequest {
  owningCompanyId?: number;
  reason?: string;
}

export const HR_ATTENDANCE_EVENT_TYPES = ['CLOCK_IN', 'CLOCK_OUT', 'DUTY_START', 'DUTY_END', 'DRIVE_START', 'DRIVE_END', 'REST_START', 'REST_END', 'BREAK_START', 'BREAK_END', 'NO_SHOW'];

export const HR_ATTENDANCE_SOURCES = ['WEB', 'MANUAL', 'MOBILE', 'GEOFENCE', 'GPS', 'IMPORT', 'BIOMETRIC_API'];

export const HR_TIMESHEET_STATUSES = ['DRAFT', 'SUBMITTED', 'APPROVED', 'LOCKED', 'REOPENED'];

export const HR_ATTENDANCE_EXCEPTION_STATUSES = ['OPEN', 'RESOLVED', 'WAIVED'];

